// extracted by mini-css-extract-plugin
export default {"button":"ButtonSubmit_button__JxCzN"};